export default function svgVideoIcon(classes) {
	return (
		<svg
			className={classes}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.8999 6.20801C21.3739 5.95601 20.766 6.02492 20.312 6.38892L17.75 8.43896V8C17.75 5.582 16.418 4.25 14 4.25H5C2.582 4.25 1.25 5.582 1.25 8V16C1.25 18.418 2.582 19.75 5 19.75H14C16.418 19.75 17.75 18.418 17.75 16V15.561L20.313 17.6121C20.585 17.8301 20.9141 17.9419 21.2471 17.9419C21.4681 17.9419 21.6899 17.893 21.8999 17.792C22.4229 17.54 22.75 17.0209 22.75 16.4399V7.56104C22.75 6.97904 22.4239 6.46101 21.8999 6.20801ZM16.25 16C16.25 17.577 15.577 18.25 14 18.25H5C3.423 18.25 2.75 17.577 2.75 16V8C2.75 6.423 3.423 5.75 5 5.75H14C15.577 5.75 16.25 6.423 16.25 8V16ZM21.25 16.4399L17.75 13.6399V10.3611L21.25 7.56104V16.4399Z"
				fill="currentColor"
			/>
		</svg>
	);
}
